export default {
	path: '/Seesee',
	meta: {
		title: '规则',
		keepAlive:true
	},
	component: r => require.ensure([], () => r(require(`./index.vue`)), `/Seesee`),
}


// WEBPACK FOOTER //
// ./src/views/Seesee/router.js